//
// # Shared server-response validators
//
// Runtime validators for server responses that are consumed in more than one
// place (Workspace instance flows + the Properties Panel controller). Kept in
// their own module so both can import them without a circular dependency.
//

import typia from "typia";
import { validate as v } from "CoreUtils";
import type {
  SymbolInfo,
  InstanceDetails,
  GeneratorParamSpec,
} from "ServerInterface";

// Validator for list-available-symbols response.
export const SymbolInfoArrayValidator = {
  validator: new v.Validator(typia.createValidate<SymbolInfo[]>()),
};

// Validator for get-symbol-param-spec response. `null` is a real answer — the
// symbol exists but has no generator behind it (a schematic builtin).
export const GeneratorParamSpecOrNullValidator = {
  validator: new v.Validator(typia.createValidate<GeneratorParamSpec | null>()),
};

// Validator for get-instance response.
export const InstanceDetailsValidator = {
  validator: new v.Validator(typia.createValidate<InstanceDetails>()),
};
